import { withPlugins, inview } from '@spon/plugins';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function CookieBanner({ plugins: { inview } }) {
	function onCookiesLoaded() {
		const cookieBanner = document.querySelector('[data-cookie]');
		const firstChapter = document.querySelector('[data-chapter]');
		ScrollTrigger.create({
			trigger: firstChapter,
			start: 'top top',
			once: true,
			onEnter: () => {
				cookieBanner.classList.add('show');
			},
		});

		document.removeEventListener('mudCookiesLoaded', onCookiesLoaded);
	}

	document.addEventListener('mudCookiesLoaded', onCookiesLoaded);

	return () => {
		document.removeEventListener('mudCookiesLoaded', onCookiesLoaded);
	};
}

export default withPlugins(inview)(CookieBanner);
